import PackageType from './PackageType.enum';
import ServiceType from './ServiceType.enum';

export default Object.freeze({
	// USPS First-Class
	UspsFirstClassMailPostcard: `${ServiceType.UspsFirstClassMail}_${PackageType.Postcard}`, // ??
	UspsFirstClassMailLetter: `${ServiceType.UspsFirstClassMail}_${PackageType.Letter}`, // ??
	UspsFirstClassMailLargeEnvelope: `${ServiceType.UspsFirstClassMail}_${PackageType.LargeEnvelope}`,
	UspsFirstClassMailPackage: `${ServiceType.UspsFirstClassMail}_${PackageType.Package}`,

	// USPS Ground Advantage
	UspsGroundAdvantagePackage: `${ServiceType.UspsGroundAdvantage}_${PackageType.Package}`,

	// USPS Priority Mail
	UspsPriorityMailLargeEnvelope: `${ServiceType.UspsPriorityMail}_${PackageType.LargeEnvelope}`,
	UspsPriorityMailPackage: `${ServiceType.UspsPriorityMail}_${PackageType.Package}`,
	UspsPriorityMailFlatRateEnvelope: `${ServiceType.UspsPriorityMail}_${PackageType.UspsFlatRateEnvelope}`,
	UspsPriorityMailPaddedFlatRateEnvelope: `${ServiceType.UspsPriorityMail}_${PackageType.UspsPaddedFlatRateEnvelope}`,
	UspsPriorityMailLegalFlatRateEnvelope: `${ServiceType.UspsPriorityMail}_${PackageType.UspsLegalFlatRateEnvelope}`,
	UspsPriorityMailSmallFlatRateBox: `${ServiceType.UspsPriorityMail}_${PackageType.UspsSmallFlatRateBox}`,
	UspsPriorityMailMediumFlatRateBox: `${ServiceType.UspsPriorityMail}_${PackageType.UspsMediumFlatRateBox}`,
	UspsPriorityMailLargeFlatRateBox: `${ServiceType.UspsPriorityMail}_${PackageType.UspsLargeFlatRateBox}`,

	// USPS Priority Mail Express
	UspsPriorityMailExpressPackage: `${ServiceType.UspsPriorityMailExpress}_${PackageType.Package}`,
	UspsPriorityMailExpressFlatRateEnvelope: `${ServiceType.UspsPriorityMailExpress}_${PackageType.UspsFlatRateEnvelope}`,
	UspsPriorityMailExpressPaddedFlatRateEnvelope: `${ServiceType.UspsPriorityMailExpress}_${PackageType.UspsPaddedFlatRateEnvelope}`,
	UspsPriorityMailExpressLegalFlatRateEnvelope: `${ServiceType.UspsPriorityMailExpress}_${PackageType.UspsLegalFlatRateEnvelope}`,

	// USPS Media Mail
	UspsMediaMailPackage: `${ServiceType.UspsMediaMail}_${PackageType.Package}`,

	// Parcel Select Ground
	UspsParcelSelectPackage: `${ServiceType.UspsParcelSelect}_${PackageType.Package}`,

	// USPS First-Class International
	UspsFirstClassMailIntlLetter: `${ServiceType.UspsFirstClassMailIntl}_${PackageType.Letter}`, // ??
	UspsFirstClassMailIntlLargeEnvelope: `${ServiceType.UspsFirstClassMailIntl}_${PackageType.LargeEnvelope}`,
	UspsFirstClassMailIntlPackage: `${ServiceType.UspsFirstClassMailIntl}_${PackageType.Package}`,

	// Priority Mail International
	UspsPriorityMailIntlPackage: `${ServiceType.UspsPriorityMailIntl}_${PackageType.Package}`,
	UspsPriorityMailIntlFlatRateEnvelope: `${ServiceType.UspsPriorityMailIntl}_${PackageType.UspsFlatRateEnvelope}`,
	UspsPriorityMailIntlPaddedFlatRateEnvelope: `${ServiceType.UspsPriorityMailIntl}_${PackageType.UspsPaddedFlatRateEnvelope}`,
	UspsPriorityMailIntlLegalFlatRateEnvelope: `${ServiceType.UspsPriorityMailIntl}_${PackageType.UspsLegalFlatRateEnvelope}`,
	UspsPriorityMailIntlSmallFlatRateBox: `${ServiceType.UspsPriorityMailIntl}_${PackageType.UspsSmallFlatRateBox}`,
	UspsPriorityMailIntlMediumFlatRateBox: `${ServiceType.UspsPriorityMailIntl}_${PackageType.UspsMediumFlatRateBox}`,
	UspsPriorityMailIntlLargeFlatRateBox: `${ServiceType.UspsPriorityMailIntl}_${PackageType.UspsLargeFlatRateBox}`,

	// Express Mail International
	UspsPriorityMailExpressIntlPackage: `${ServiceType.UspsPriorityMailExpressIntl}_${PackageType.Package}`,
	UspsPriorityMailExpressIntlFlatRateEnvelope: `${ServiceType.UspsPriorityMailExpressIntl}_${PackageType.UspsFlatRateEnvelope}`,
	UspsPriorityMailExpressIntlPaddedFlatRateEnvelope: `${ServiceType.UspsPriorityMailExpressIntl}_${PackageType.UspsPaddedFlatRateEnvelope}`,
	UspsPriorityMailExpressIntlLegalFlatRateEnvelope: `${ServiceType.UspsPriorityMailExpressIntl}_${PackageType.UspsLegalFlatRateEnvelope}`,

	// UPS Ground
	UpsGroundPackage: `${ServiceType.UpsGround}_${PackageType.Package}`,

	// UPS Ground Saver
	UpsGroundSaverPackage: `${ServiceType.UpsGroundSaver}_${PackageType.Package}`,

	// UPS 3 Day Select
	Ups3DaySelectPackage: `${ServiceType.Ups3DaySelect}_${PackageType.Package}`,

	// UPS 2nd Day Air
	Ups2ndDayAirPackage: `${ServiceType.Ups2ndDayAir}_${PackageType.Package}`,
	Ups2ndDayAirLetter: `${ServiceType.Ups2ndDayAir}_${PackageType.UpsLetter}`,
	Ups2ndDayAirExpressBoxSmall: `${ServiceType.Ups2ndDayAir}_${PackageType.UpsExpressBoxSmall}`,
	Ups2ndDayAirExpressBoxMedium: `${ServiceType.Ups2ndDayAir}_${PackageType.UpsExpressBoxMedium}`,
	Ups2ndDayAirExpressBoxLarge: `${ServiceType.Ups2ndDayAir}_${PackageType.UpsExpressBoxLarge}`,
	Ups2ndDayAirTube: `${ServiceType.Ups2ndDayAir}_${PackageType.UpsTube}`,
	Ups2ndDayAirPak: `${ServiceType.Ups2ndDayAir}_${PackageType.UpsPak}`,

	// UPS 2nd Day Air A.M
	Ups2ndDayAirAmPackage: `${ServiceType.Ups2ndDayAirAm}_${PackageType.Package}`,
	Ups2ndDayAirAmLetter: `${ServiceType.Ups2ndDayAirAm}_${PackageType.UpsLetter}`,
	Ups2ndDayAirAmExpressBoxSmall: `${ServiceType.Ups2ndDayAirAm}_${PackageType.UpsExpressBoxSmall}`,
	Ups2ndDayAirAmExpressBoxMedium: `${ServiceType.Ups2ndDayAirAm}_${PackageType.UpsExpressBoxMedium}`,
	Ups2ndDayAirAmExpressBoxLarge: `${ServiceType.Ups2ndDayAirAm}_${PackageType.UpsExpressBoxLarge}`,
	Ups2ndDayAirAmTube: `${ServiceType.Ups2ndDayAirAm}_${PackageType.UpsTube}`,
	Ups2ndDayAirAmPak: `${ServiceType.Ups2ndDayAirAm}_${PackageType.UpsPak}`,

	// UPS Next Day Air Saver
	UpsNextDayAirSaverPackage: `${ServiceType.UpsNextDayAirSaver}_${PackageType.Package}`,
	UpsNextDayAirSaverLetter: `${ServiceType.UpsNextDayAirSaver}_${PackageType.UpsLetter}`,
	UpsNextDayAirSaverExpressBoxSmall: `${ServiceType.UpsNextDayAirSaver}_${PackageType.UpsExpressBoxSmall}`,
	UpsNextDayAirSaverExpressBoxMedium: `${ServiceType.UpsNextDayAirSaver}_${PackageType.UpsExpressBoxMedium}`,
	UpsNextDayAirSaverExpressBoxLarge: `${ServiceType.UpsNextDayAirSaver}_${PackageType.UpsExpressBoxLarge}`,
	UpsNextDayAirSaverTube: `${ServiceType.UpsNextDayAirSaver}_${PackageType.UpsTube}`,
	UpsNextDayAirSaverPak: `${ServiceType.UpsNextDayAirSaver}_${PackageType.UpsPak}`,

	// UPS Next Day Air
	UpsNextDayAirPackage: `${ServiceType.UpsNextDayAir}_${PackageType.Package}`,
	UpsNextDayAirLetter: `${ServiceType.UpsNextDayAir}_${PackageType.UpsLetter}`,
	UpsNextDayAirExpressBoxSmall: `${ServiceType.UpsNextDayAir}_${PackageType.UpsExpressBoxSmall}`,
	UpsNextDayAirExpressBoxMedium: `${ServiceType.UpsNextDayAir}_${PackageType.UpsExpressBoxMedium}`,
	UpsNextDayAirExpressBoxLarge: `${ServiceType.UpsNextDayAir}_${PackageType.UpsExpressBoxLarge}`,
	UpsNextDayAirTube: `${ServiceType.UpsNextDayAir}_${PackageType.UpsTube}`,
	UpsNextDayAirPak: `${ServiceType.UpsNextDayAir}_${PackageType.UpsPak}`,

	// UPS Next Day Air Early
	UpsNextDayAirEarlyPackage: `${ServiceType.UpsNextDayAirEarly}_${PackageType.Package}`,
	UpsNextDayAirEarlyLetter: `${ServiceType.UpsNextDayAirEarly}_${PackageType.UpsLetter}`,
	UpsNextDayAirEarlyExpressBoxSmall: `${ServiceType.UpsNextDayAirEarly}_${PackageType.UpsExpressBoxSmall}`,
	UpsNextDayAirEarlyExpressBoxMedium: `${ServiceType.UpsNextDayAirEarly}_${PackageType.UpsExpressBoxMedium}`,
	UpsNextDayAirEarlyExpressBoxLarge: `${ServiceType.UpsNextDayAirEarly}_${PackageType.UpsExpressBoxLarge}`,
	UpsNextDayAirEarlyTube: `${ServiceType.UpsNextDayAirEarly}_${PackageType.UpsTube}`,
	UpsNextDayAirEarlyPak: `${ServiceType.UpsNextDayAirEarly}_${PackageType.UpsPak}`,

	// UPS Standard
	UpsStandardPackage: `${ServiceType.UpsStandard}_${PackageType.Package}`,

	// UPS Worldwide Expedited
	UpsWorldwideExpeditedPackage: `${ServiceType.UpsWorldwideExpedited}_${PackageType.Package}`,
	UpsWorldwideExpeditedExpressBoxSmall: `${ServiceType.UpsWorldwideExpedited}_${PackageType.UpsExpressBoxSmall}`,
	UpsWorldwideExpeditedExpressBoxMedium: `${ServiceType.UpsWorldwideExpedited}_${PackageType.UpsExpressBoxMedium}`,
	UpsWorldwideExpeditedExpressBoxLarge: `${ServiceType.UpsWorldwideExpedited}_${PackageType.UpsExpressBoxLarge}`,
	UpsWorldwideExpeditedTube: `${ServiceType.UpsWorldwideExpedited}_${PackageType.UpsTube}`,
	UpsWorldwideExpeditedPak: `${ServiceType.UpsWorldwideExpedited}_${PackageType.UpsPak}`,

	// UPS Worldwide Saver
	UpsWorldwideSaverPackage: `${ServiceType.UpsWorldwideSaver}_${PackageType.Package}`,
	UpsWorldwideSaverLetter: `${ServiceType.UpsWorldwideSaver}_${PackageType.UpsLetter}`,
	UpsWorldwideSaverExpressBoxSmall: `${ServiceType.UpsWorldwideSaver}_${PackageType.UpsExpressBoxSmall}`,
	UpsWorldwideSaverExpressBoxMedium: `${ServiceType.UpsWorldwideSaver}_${PackageType.UpsExpressBoxMedium}`,
	UpsWorldwideSaverExpressBoxLarge: `${ServiceType.UpsWorldwideSaver}_${PackageType.UpsExpressBoxLarge}`,
	UpsWorldwideSaverTube: `${ServiceType.UpsWorldwideSaver}_${PackageType.UpsTube}`,
	UpsWorldwideSaverPak: `${ServiceType.UpsWorldwideSaver}_${PackageType.UpsPak}`,

	// UPS Worldwide Express
	UpsWorldwideExpressPackage: `${ServiceType.UpsWorldwideExpress}_${PackageType.Package}`,
	UpsWorldwideExpressLetter: `${ServiceType.UpsWorldwideExpress}_${PackageType.UpsLetter}`,
	UpsWorldwideExpressExpressBoxSmall: `${ServiceType.UpsWorldwideExpress}_${PackageType.UpsExpressBoxSmall}`,
	UpsWorldwideExpressExpressBoxMedium: `${ServiceType.UpsWorldwideExpress}_${PackageType.UpsExpressBoxMedium}`,
	UpsWorldwideExpressExpressBoxLarge: `${ServiceType.UpsWorldwideExpress}_${PackageType.UpsExpressBoxLarge}`,
	UpsWorldwideExpressTube: `${ServiceType.UpsWorldwideExpress}_${PackageType.UpsTube}`,
	UpsWorldwideExpressPak: `${ServiceType.UpsWorldwideExpress}_${PackageType.UpsPak}`,

	// UPS Worldwide Express Plus
	UpsWorldwideExpressPlusPackage: `${ServiceType.UpsWorldwideExpressPlus}_${PackageType.Package}`,
	UpsWorldwideExpressPlusLetter: `${ServiceType.UpsWorldwideExpressPlus}_${PackageType.UpsLetter}`,
	UpsWorldwideExpressPlusExpressBoxSmall: `${ServiceType.UpsWorldwideExpressPlus}_${PackageType.UpsExpressBoxSmall}`,
	UpsWorldwideExpressPlusExpressBoxMedium: `${ServiceType.UpsWorldwideExpressPlus}_${PackageType.UpsExpressBoxMedium}`,
	UpsWorldwideExpressPlusExpressBoxLarge: `${ServiceType.UpsWorldwideExpressPlus}_${PackageType.UpsExpressBoxLarge}`,
	UpsWorldwideExpressPlusTube: `${ServiceType.UpsWorldwideExpressPlus}_${PackageType.UpsTube}`,
	UpsWorldwideExpressPlusPak: `${ServiceType.UpsWorldwideExpressPlus}_${PackageType.UpsPak}`,

	// DHL Express World Wide
	DhlExpressWorldwidePackage: `${ServiceType.DhlExpressWorldwide}_${PackageType.Package}`,
	DhlExpressWorldwideExpressEnvelope: `${ServiceType.DhlExpressWorldwide}_${PackageType.ExpressEnvelope}`,

	// FedEx Ground
	FedExGroundPackage: `${ServiceType.FedExGround}_${PackageType.Package}`,

	// FedEx Ground Economy
	FedExGroundEconomyPackage: `${ServiceType.FedExGroundEconomy}_${PackageType.Package}`,

	// FedEx Home Delivery
	FedExHomeDeliveryPackage: `${ServiceType.FedExHomeDelivery}_${PackageType.Package}`,

	// FedEx Express Saver
	FedExExpressSaverPackage: `${ServiceType.FedExExpressSaver}_${PackageType.Package}`,
	FedExExpressSaverEnvelope: `${ServiceType.FedExExpressSaver}_${PackageType.FedExEnvelope}`,
	FedExExpressSaverPak: `${ServiceType.FedExExpressSaver}_${PackageType.FedExPak}`,
	FedExExpressSaverTube: `${ServiceType.FedExExpressSaver}_${PackageType.FedExTube}`,
	FedExExpressSaverOneRateSmallBox: `${ServiceType.FedExExpressSaver}_${PackageType.FedExOneRateSmallBox}`,
	FedExExpressSaverOneRateMediumBox: `${ServiceType.FedExExpressSaver}_${PackageType.FedExOneRateMediumBox}`,
	FedExExpressSaverOneRateLargeBox: `${ServiceType.FedExExpressSaver}_${PackageType.FedExOneRateLargeBox}`,
	FedExExpressSaverOneRateExtraLargeBox: `${ServiceType.FedExExpressSaver}_${PackageType.FedExOneRateExtraLargeBox}`,
	FedExExpressSaverFedExOneRateEnvelope: `${ServiceType.FedExExpressSaver}_${PackageType.FedExOneRateEnvelope}`,
	FedExExpressSaverOneRatePak: `${ServiceType.FedExExpressSaver}_${PackageType.FedExOneRatePak}`,
	FedExExpressSaverOneRateTube: `${ServiceType.FedExExpressSaver}_${PackageType.FedExOneRateTube}`,

	// FedEx 2Day
	FedEx2DayPackage: `${ServiceType.FedEx2Day}_${PackageType.Package}`,
	FedEx2DayEnvelope: `${ServiceType.FedEx2Day}_${PackageType.FedExEnvelope}`,
	FedEx2DayPak: `${ServiceType.FedEx2Day}_${PackageType.FedExPak}`,
	FedEx2DayTube: `${ServiceType.FedEx2Day}_${PackageType.FedExTube}`,
	FedEx2DayFedExOneRateSmallBox: `${ServiceType.FedEx2Day}_${PackageType.FedExOneRateSmallBox}`,
	FedEx2DayFedExOneRateMediumBox: `${ServiceType.FedEx2Day}_${PackageType.FedExOneRateMediumBox}`,
	FedEx2DayFedExOneRateLargeBox: `${ServiceType.FedEx2Day}_${PackageType.FedExOneRateLargeBox}`,
	FedEx2DayFedExOneRateExtraLargeBox: `${ServiceType.FedEx2Day}_${PackageType.FedExOneRateExtraLargeBox}`,
	FedEx2DayFedExOneRateEnvelope: `${ServiceType.FedEx2Day}_${PackageType.FedExOneRateEnvelope}`,
	FedEx2DayFedExOneRatePak: `${ServiceType.FedEx2Day}_${PackageType.FedExOneRatePak}`,
	FedEx2DayFedExOneRateTube: `${ServiceType.FedEx2Day}_${PackageType.FedExOneRateTube}`,
	FedEx2DayFedExSmallBox: `${ServiceType.FedEx2Day}_${PackageType.FedExSmallBox}`,
	FedEx2DayFedExMediumBox: `${ServiceType.FedEx2Day}_${PackageType.FedExMediumBox}`,
	FedEx2DayFedExLargeBox: `${ServiceType.FedEx2Day}_${PackageType.FedExLargeBox}`,
	FedEx2DayFedExExtraLargeBox: `${ServiceType.FedEx2Day}_${PackageType.FedExExtraLargeBox}`,

	// FedEx 2Day One Rate
	FedEx2DayOneRatePackage: `${ServiceType.FedEx2DayOneRate}_${PackageType.Package}`,
	FedEx2DayOneRateEnvelope: `${ServiceType.FedEx2DayOneRate}_${PackageType.FedExEnvelope}`,
	FedEx2DayOneRatePak: `${ServiceType.FedEx2DayOneRate}_${PackageType.FedExPak}`,
	FedEx2DayOneRateFedExSmallBox: `${ServiceType.FedEx2DayOneRate}_${PackageType.FedExSmallBox}`,
	FedEx2DayOneRateFedExMediumBox: `${ServiceType.FedEx2DayOneRate}_${PackageType.FedExMediumBox}`,
	FedEx2DayOneRateFedExLargeBox: `${ServiceType.FedEx2DayOneRate}_${PackageType.FedExLargeBox}`,
	FedEx2DayOneRateFedExExtraLargeBox: `${ServiceType.FedEx2DayOneRate}_${PackageType.FedExExtraLargeBox}`,

	// FedEx 2Day A.M.
	FedEx2DayAmPackage: `${ServiceType.FedEx2DayAm}_${PackageType.Package}`,
	FedEx2DayAmEnvelope: `${ServiceType.FedEx2DayAm}_${PackageType.FedExEnvelope}`,
	FedEx2DayAmPak: `${ServiceType.FedEx2DayAm}_${PackageType.FedExPak}`,
	FedEx2DayAmTube: `${ServiceType.FedEx2DayAm}_${PackageType.FedExTube}`,
	FedEx2DayAmOneRateSmallBox: `${ServiceType.FedEx2DayAm}_${PackageType.FedExOneRateSmallBox}`,
	FedEx2DayAmOneRateMediumBox: `${ServiceType.FedEx2DayAm}_${PackageType.FedExOneRateMediumBox}`,
	FedEx2DayAmOneRateLargeBox: `${ServiceType.FedEx2DayAm}_${PackageType.FedExOneRateLargeBox}`,
	FedEx2DayAmOneRateExtraLargeBox: `${ServiceType.FedEx2DayAm}_${PackageType.FedExOneRateExtraLargeBox}`,
	FedEx2DayAmOneRateEnvelope: `${ServiceType.FedEx2DayAm}_${PackageType.FedExOneRateEnvelope}`,
	FedEx2DayAmOneRatePak: `${ServiceType.FedEx2DayAm}_${PackageType.FedExOneRatePak}`,
	FedEx2DayAmOneRateTube: `${ServiceType.FedEx2DayAm}_${PackageType.FedExOneRateTube}`,

	// FedEx Standard Overnight
	FedExStandardOvernightPackage: `${ServiceType.FedExStandardOvernight}_${PackageType.Package}`,
	FedExStandardOvernightEnvelope: `${ServiceType.FedExStandardOvernight}_${PackageType.FedExEnvelope}`,
	FedExStandardOvernightPak: `${ServiceType.FedExStandardOvernight}_${PackageType.FedExPak}`,
	FedExStandardOvernightTube: `${ServiceType.FedExStandardOvernight}_${PackageType.FedExTube}`,
	FedExStandardOvernightOneRateSmallBox: `${ServiceType.FedExStandardOvernight}_${PackageType.FedExOneRateSmallBox}`,
	FedExStandardOvernightOneRateMediumBox: `${ServiceType.FedExStandardOvernight}_${PackageType.FedExOneRateMediumBox}`,
	FedExStandardOvernightOneRateLargeBox: `${ServiceType.FedExStandardOvernight}_${PackageType.FedExOneRateLargeBox}`,
	FedExStandardOvernightOneRateExtraLargeBox: `${ServiceType.FedExStandardOvernight}_${PackageType.FedExOneRateExtraLargeBox}`,
	FedExStandardOvernightOneRateEnvelope: `${ServiceType.FedExStandardOvernight}_${PackageType.FedExOneRateEnvelope}`,
	FedExStandardOvernightOneRatePak: `${ServiceType.FedExStandardOvernight}_${PackageType.FedExOneRatePak}`,
	FedExStandardOvernightOneRateTube: `${ServiceType.FedExStandardOvernight}_${PackageType.FedExOneRateTube}`,

	// FedEx Priority Overnight
	FedExPriorityOvernightPackage: `${ServiceType.FedExPriorityOvernight}_${PackageType.Package}`,
	FedExPriorityOvernightEnvelope: `${ServiceType.FedExPriorityOvernight}_${PackageType.FedExEnvelope}`,
	FedExPriorityOvernightPak: `${ServiceType.FedExPriorityOvernight}_${PackageType.FedExPak}`,
	FedExPriorityOvernightTube: `${ServiceType.FedExPriorityOvernight}_${PackageType.FedExTube}`,
	FedExPriorityOvernightOneRateSmallBox: `${ServiceType.FedExPriorityOvernight}_${PackageType.FedExOneRateSmallBox}`,
	FedExPriorityOvernightOneRateMediumBox: `${ServiceType.FedExPriorityOvernight}_${PackageType.FedExOneRateMediumBox}`,
	FedExPriorityOvernightOneRateLargeBox: `${ServiceType.FedExPriorityOvernight}_${PackageType.FedExOneRateLargeBox}`,
	FedExPriorityOvernightOneRateExtraLargeBox: `${ServiceType.FedExPriorityOvernight}_${PackageType.FedExOneRateExtraLargeBox}`,
	FedExPriorityOvernightOneRateEnvelope: `${ServiceType.FedExPriorityOvernight}_${PackageType.FedExOneRateEnvelope}`,
	FedExPriorityOvernightOneRatePak: `${ServiceType.FedExPriorityOvernight}_${PackageType.FedExOneRatePak}`,
	FedExPriorityOvernightOneRateTube: `${ServiceType.FedExPriorityOvernight}_${PackageType.FedExOneRateTube}`,

	// FedEx First Overnight
	FedExFirstOvernightPackage: `${ServiceType.FedExFirstOvernight}_${PackageType.Package}`,
	FedExFirstOvernightEnvelope: `${ServiceType.FedExFirstOvernight}_${PackageType.FedExEnvelope}`,
	FedExFirstOvernightPak: `${ServiceType.FedExFirstOvernight}_${PackageType.FedExPak}`,
	FedExFirstOvernightTube: `${ServiceType.FedExFirstOvernight}_${PackageType.FedExTube}`,
	FedExFirstOvernightOneRateSmallBox: `${ServiceType.FedExFirstOvernight}_${PackageType.FedExOneRateSmallBox}`,
	FedExFirstOvernightOneRateMediumBox: `${ServiceType.FedExFirstOvernight}_${PackageType.FedExOneRateMediumBox}`,
	FedExFirstOvernightOneRateLargeBox: `${ServiceType.FedExFirstOvernight}_${PackageType.FedExOneRateLargeBox}`,
	FedExFirstOvernightOneRateExtraLargeBox: `${ServiceType.FedExFirstOvernight}_${PackageType.FedExOneRateExtraLargeBox}`,
	FedExFirstOvernightOneRateEnvelope: `${ServiceType.FedExFirstOvernight}_${PackageType.FedExOneRateEnvelope}`,
	FedExFirstOvernightOneRatePak: `${ServiceType.FedExFirstOvernight}_${PackageType.FedExOneRatePak}`,
	FedExFirstOvernightOneRateTube: `${ServiceType.FedExFirstOvernight}_${PackageType.FedExOneRateTube}`,

	// FedEx International Ground
	FedExIntlGroundPackage: `${ServiceType.FedExIntlGround}_${PackageType.Package}`,

	// FedEx International Economy
	FedExIntlEconomyPackage: `${ServiceType.FedExIntlEconomy}_${PackageType.Package}`,
	FedExIntlEconomyEnvelope: `${ServiceType.FedExIntlEconomy}_${PackageType.FedExEnvelope}`,
	FedExIntlEconomyPak: `${ServiceType.FedExIntlEconomy}_${PackageType.FedExPak}`,
	FedExIntlEconomyTube: `${ServiceType.FedExIntlEconomy}_${PackageType.FedExTube}`,

	// FedEx International Priority
	FedExIntlPriorityPackage: `${ServiceType.FedExIntlPriority}_${PackageType.Package}`,
	FedExIntlPriorityEnvelope: `${ServiceType.FedExIntlPriority}_${PackageType.FedExEnvelope}`,
	FedExIntlPriorityPak: `${ServiceType.FedExIntlPriority}_${PackageType.FedExPak}`,
	FedExIntlPriorityTube: `${ServiceType.FedExIntlPriority}_${PackageType.FedExTube}`,
	FedExIntlPriority10kgBox: `${ServiceType.FedExIntlPriority}_${PackageType.FedEx10kgBox}`,
	FedExIntlPriority25kgBox: `${ServiceType.FedExIntlPriority}_${PackageType.FedEx25kgBox}`,

	// FedEx International First
	FedExIntlFirstPackage: `${ServiceType.FedExIntlFirst}_${PackageType.Package}`,
	FedExIntlFirstEnvelope: `${ServiceType.FedExIntlFirst}_${PackageType.FedExEnvelope}`,
	FedExIntlFirstPak: `${ServiceType.FedExIntlFirst}_${PackageType.FedExPak}`,
	FedExIntlFirstTube: `${ServiceType.FedExIntlFirst}_${PackageType.FedExTube}`,

	// FedEx International Connect Plus
	FedExIntlConnectPlusPackage: `${ServiceType.FedExIntlConnectPlus}_${PackageType.Package}`,
	FedExIntlConnectPlusEnvelope: `${ServiceType.FedExIntlConnectPlus}_${PackageType.FedExEnvelope}`,
	FedExIntlConnectPlusPak: `${ServiceType.FedExIntlConnectPlus}_${PackageType.FedExPak}`,
	FedExIntlConnectPlusTube: `${ServiceType.FedExIntlConnectPlus}_${PackageType.FedExTube}`,
	FedExIntlConnectPlusBox: `${ServiceType.FedExIntlConnectPlus}_${PackageType.FedExBox}`,
	FedExIntlConnectPlusSmallBox: `${ServiceType.FedExIntlConnectPlus}_${PackageType.FedExSmallBox}`,
	FedExIntlConnectPlusMediumBox: `${ServiceType.FedExIntlConnectPlus}_${PackageType.FedExMediumBox}`,
	FedExIntlConnectPlusLargeBox: `${ServiceType.FedExIntlConnectPlus}_${PackageType.FedExLargeBox}`,
	FedExIntlConnectPlusExtraLargeBox: `${ServiceType.FedExIntlConnectPlus}_${PackageType.FedExExtraLargeBox}`,

	// GlobalPost First-Class SmartSaver Domestic Service
	GlobalPostFirstClassSmartSaverLargeEnvelope: `${ServiceType.GlobalPostFirstClassSmartSaver}_${PackageType.LargeEnvelope}`,
	GlobalPostFirstClassSmartSaverPackage: `${ServiceType.GlobalPostFirstClassSmartSaver}_${PackageType.Package}`,

	// GlobalPost Parcel Select SmartSaver Domestic Service
	GlobalPostParcelSelectSmartSaverPackage: `${ServiceType.GlobalPostParcelSelectSmartSaver}_${PackageType.Package}`,

	// GlobalPost Economy Service
	GlobalPostEconomyIntlLargeEnvelope: `${ServiceType.GlobalPostEconomyIntl}_${PackageType.LargeEnvelope}`,
	GlobalPostEconomyIntlPackage: `${ServiceType.GlobalPostEconomyIntl}_${PackageType.Package}`,

	// GlobalPost SmartSaver Economy Service
	GlobalPostEconomyIntlSmartSaverLargeEnvelope: `${ServiceType.GlobalPostEconomyIntlSmartSaver}_${PackageType.LargeEnvelope}`,
	GlobalPostEconomyIntlSmartSaverPackage: `${ServiceType.GlobalPostEconomyIntlSmartSaver}_${PackageType.Package}`,

	// GlobalPost Standard Service
	GlobalPostStandardIntlLargeEnvelope: `${ServiceType.GlobalPostStandardIntl}_${PackageType.LargeEnvelope}`,
	GlobalPostStandardIntlPackage: `${ServiceType.GlobalPostStandardIntl}_${PackageType.Package}`,
	GlobalPostStandardIntlFlatRateEnvelope: `${ServiceType.GlobalPostStandardIntl}_${PackageType.UspsFlatRateEnvelope}`,
	GlobalPostStandardIntlLegalFlatRateEnvelope: `${ServiceType.GlobalPostStandardIntl}_${PackageType.UspsLegalFlatRateEnvelope}`,
	GlobalPostStandardIntlPaddedFlatRateEnvelope: `${ServiceType.GlobalPostStandardIntl}_${PackageType.UspsPaddedFlatRateEnvelope}`,
	GlobalPostStandardIntlSmallFlatRateBox: `${ServiceType.GlobalPostStandardIntl}_${PackageType.UspsSmallFlatRateBox}`,

	// GlobalPost SmartSaver Standard Service
	GlobalPostStandardIntlSmartSaverLargeEnvelope: `${ServiceType.GlobalPostStandardIntlSmartSaver}_${PackageType.LargeEnvelope}`,
	GlobalPostStandardIntlSmartSaverPackage: `${ServiceType.GlobalPostStandardIntlSmartSaver}_${PackageType.Package}`,

	// GlobalPost SmartSaver Plus Service
	GlobalPostPlusSmartSaverLargeEnvelope: `${ServiceType.GlobalPostPlusSmartSaver}_${PackageType.LargeEnvelope}`,
	GlobalPostPlusSmartSaverPackage: `${ServiceType.GlobalPostPlusSmartSaver}_${PackageType.Package}`,

	// GlobalPost Plus Service
	GlobalPostPlusIntlLargeEnvelope: `${ServiceType.GlobalPostPlus}_${PackageType.LargeEnvelope}`,
	GlobalPostPlusIntlPackage: `${ServiceType.GlobalPostPlus}_${PackageType.Package}`,

	// GlobalPost Flat Rate Service
	GlobalPostFlatRatePackage: `${ServiceType.GlobalPostFlatRate}_${PackageType.Package}`,

	// GlobalPost Edge Service
	GlobalPostEdgePackage: `${ServiceType.GlobalPostEdge}_${PackageType.Package}`,

	// GlobalPost 2-Day Promise Service
	GlobalPost2DayPromisePackage: `${ServiceType.GlobalPost2DayPromise}_${PackageType.Package}`,

	// USPS Ground Advantage (GDE) Service
	GlobalPostGdeGroundAdvantagePackage: `${ServiceType.GlobalPostGdeGroundAdvantage}_${PackageType.Package}`,

	// USPS Priority Mail (GDE) Service
	GlobalPostGdePriorityMailPackage: `${ServiceType.GlobalPostGdePriorityMail}_${PackageType.Package}`,

	// GlobalPost Plus - Duties and Taxes Included Service
	GlobalPostPlusDutiesAndTaxesLargeEnvelope: `${ServiceType.GlobalPostPlusDutiesAndTaxes}_${PackageType.LargeEnvelope}`,
	GlobalPostPlusDutiesAndTaxesPackage: `${ServiceType.GlobalPostPlusDutiesAndTaxes}_${PackageType.Package}`,
});
